module.exports = __webpack_public_path__ + "img/login-background.7492460c.jpg";